federations:
  title: "Federaties"
  subtitle: "Beheer de federaties (bonden) waar clubs onder vallen."
  empty: "Nog geen federaties toegevoegd."
  searchPlaceholder: "Zoek op naam"
  create: "Federatie toevoegen"
  edit: "Federatie aanpassen"
  created: "Federatie toegevoegd."
  updated: "Federatie bijgewerkt."
  deleted: "Federatie verwijderd."
  deleteConfirmTitle: "Federatie verwijderen?"
  columns:
    shortName: "Afkorting"
    longName: "Volledige naam"
    type: "Type"
  types:
    SOCCER: "Voetbal"
    HOCKEY: "Hockey"
    TENNIS: "Tennis"
